let dt_index = null;
let dt_submenu = null;
let microsite_id = null;


export function index(params){

    dt_index = $('#menus_table').DataTable({
        ajax: {
            url: $('#menus_table').attr('url'),
        },
        select: {
            style: 'multi+shift',
        },
        columns: [
            { width: '20', data: 'id', orderable: false, searchable: false, checkboxes: { selectRow: true } },
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_menus_actions },
            { width: '20', data: 'visibility', class: 'px-0', orderable: false, searchable: false , render: render_menus_visible},
            { width: '50', data: 'order', class: 'text-right', orderable: true, searchable: true },
            { data: 'name', orderable: true, searchable: true },
        ],
        order: [3, 'asc'],
    });

    dt_index.on('init', function(e, settings, json){
        $(settings.nTableWrapper).find('.table_batch_actions [action="delete_menus"]').click(batch_delete_menus);
    });

    // dt_index.on('draw', function(e, settings){
    //     $(settings.nTableWrapper).find('.update_active').click(update_active);
    // });

    microsite_id = params.microsite_id;
}

function render_menus_actions(data, type, row){

    const url_info = ($("#menus_table").attr('url_info') ?? '').replace('#', row.id);

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
        '</div>';

    return actions;
}

function render_menus_visible(data, type, row){

    let visibility = '<div class="btn-group" role="group">';

    switch (row.visible) {

        case 'hidden':
            visibility +='   <button class="btn btn-default btn-xs btn-visibility visibility disabled" title="' + window.__(row.visibility) + '"><i class="fa-solid fa-eye-slash"></i></button>';
            break;

        case 'visible':    
            visibility +='   <button class="btn btn-primary btn-xs btn-visibility visibility disabled" title="' + window.__(row.visibility) + '"><i class="fa-solid fa-eye"></i></button>';
            break;

        case 'only_guest':
            visibility +='   <button class="btn btn-secondary btn-xs btn-visibility visibility disabled" title="' + window.__(row.visibility) + '"><i class="fa-solid fa-user-secret"></i></button>';
            break;

        case 'only_users':
            visibility +='   <button class="btn btn-info btn-xs btn-visibility visibility disabled" title="' + window.__(row.visibility) + '"><i class="fa-solid fa-user"></i></button>';
            break;

        case 'only_health':
            visibility +='   <button class="btn btn-success btn-xs btn-visibility visibility disabled" title="' + window.__(row.visibility) + '"><i class="fa-solid fa-user-doctor"></i></button>';
            break;
            
    }
            
    visibility += '</div>';

    return visibility;
}

//create

export function create(){
    let form = $('#new_menu');

    let type = form.find('[name="menu_type"]');

    type.on('change', function(){
        show_hide_select_options($(this).val());
    });

}

function show_hide_select_options(value) {
    switch (value) {
        case 'link':
            $('select[name="target_type"]').closest('.col').removeClass('d-none');
            $('input[name="menu_link"]').closest('.x-form-input').removeClass('d-none');
            $('select[name="content_id"]').closest('.x-form-input').addClass('d-none');
            $('select[name="category_id"]').closest('.x-form-input').addClass('d-none');
            $('select[name="layout"]').closest('.x-form-input').addClass('d-none');
            $('select[name="tag_id"]').closest('.x-form-input').addClass('d-none');

            break;
        case 'content':
            $('select[name="target_type"]').closest('.col').removeClass('d-none');
            $('input[name="menu_link"]').closest('.x-form-input').addClass('d-none');
            $('select[name="content_id"]').closest('.x-form-input').removeClass('d-none');
            $('select[name="category_id"]').closest('.x-form-input').addClass('d-none');
            $('select[name="layout"]').closest('.x-form-input').addClass('d-none');
            $('select[name="tag_id"]').closest('.x-form-input').addClass('d-none');

            break;
    
        case 'category':
            $('select[name="target_type"]').closest('.col').removeClass('d-none');
            $('input[name="menu_link"]').closest('.x-form-input').addClass('d-none');
            $('select[name="content_id"]').closest('.x-form-input').addClass('d-none');
            $('select[name="category_id"]').closest('.x-form-input').removeClass('d-none');
            $('select[name="layout"]').closest('.x-form-input').removeClass('d-none');
            $('select[name="tag_id"]').closest('.x-form-input').addClass('d-none');

            break;

        case 'tag':
            $('select[name="target_type"]').closest('.col').removeClass('d-none');
            $('input[name="menu_link"]').closest('.x-form-input').addClass('d-none');
            $('select[name="content_id"]').closest('.x-form-input').addClass('d-none');
            $('select[name="category_id"]').closest('.x-form-input').addClass('d-none');
            $('select[name="layout"]').closest('.x-form-input').addClass('d-none');
            $('select[name="tag_id"]').closest('.x-form-input').removeClass('d-none');

            break;

        default:
            $('select[name="target_type"]').closest('.x-form-input').addClass('d-none');
            $('input[name="menu_link"]').closest('.x-form-input').addClass('d-none');
            $('select[name="content_id"]').closest('.x-form-input').addClass('d-none');
            $('select[name="category_id"]').closest('.x-form-input').addClass('d-none');
            $('select[name="layout"]').closest('.x-form-input').addClass('d-none');
            $('select[name="tag_id"]').closest('.x-form-input').addClass('d-none');

            break;
    }
}

export function filter_entries(data) {

    let results = $.map(data.results, function(obj, index) {
        return { 
            id: obj.id, 
            text: obj.title,
            result: obj.title + '<small class="d-block font-weight-light">' + obj.slug + "</small>"
        };
    });

    return {
        results: results
    };
}

export function filter_categories(data) {
    
    let results = $.map(data.results, function(obj, index) {
        return { 
            id: obj.id, 
            text: obj.name,
            result: obj.name + '<small class="d-block font-weight-light">' + obj.slug + "</small>"
        };
    });

    return {
        results: results
    };
}

export function show(params){

    microsite_id = params.microsite_id;
    
    // datatable microsite_users
    
    dt_submenu = $('#submenus_table').DataTable({
        ajax: {
            url: $('#submenus_table').attr('url'),
        },
        select: {
            style: 'multi+shift',
        },
        autoWidth: false,
        columns: [
            { width: '20', data: 'id', orderable: false, searchable: false, checkboxes: { selectRow: true } },
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_submenus_actions },
            { width: '20', data: 'visibility', class: 'px-0', orderable: false, searchable: false , render: render_menus_visible},
            { width: '50', data: 'order', class: 'text-right', orderable: true, searchable: true },
            { data: 'name', orderable: true, searchable: true },
        ],
        order: [3, 'asc'],
    });

    dt_submenu.on('init', function(e, settings, json){
        $(settings.nTableWrapper).find('.table_batch_actions [action="delete_menus"]').click(batch_delete_menus);
    });

    // dt_submenu.on('draw', function(e, settings){
    // });
    let form = $('#edit_menu');
    let type = form.find('[name="menu_type"]');

    type.on('change', function(){
        show_hide_select_options($(this).val());
    });



    show_hide_select_options(type.val());
}

function render_submenus_actions(data, type, row){

    const url = ($("#submenus_table").attr('url'));

    const url_info = ($("#submenus_table").attr('url_info') ?? '').replace('#', row.id);

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
        '</div>';

    return actions;

}

export function index_reload(){
    
    if(dt_index != null){
        dt_index.ajax.reload();
    }

    if(dt_submenu != null){
        dt_submenu.ajax.reload();
    }

}

export function index_force_reload(){

    if(dt_index != null){
        dt_index.column(0).checkboxes.deselectAll();
        dt_index.ajax.reload();
    }

    if(dt_submenu != null){
        dt_submenu.column(0).checkboxes.deselectAll();
        dt_submenu.ajax.reload();
    }

}

function batch_delete_menus(){

    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    const rows_selected = table.column(0).checkboxes.selected();
    const route = window._routes['microsites.menus.batch_delete'].replace('{microsite}', microsite_id);
    
    let menus_id = [];
    $.each(rows_selected, function(index, rowId){
        menus_id.push(rowId);
    });
    
    if(menus_id.length == 0){

        window.messages.error(__('No has seleccionado ningún menú'));

    } else {

        const title = __('Eliminar menús');
        const text = 
            trans_choice('{1} Estás a punto de eliminar un menú.|[2,*] Estás a punto de eliminar :count menus.', menus_id.length)
            + ' ' + __('Esta acción no se puede deshacer ¿quieres continuar?');
        
        window.messages
            .confirm(title, text)
            .then(
                _ => {

                    let formData = new FormData();
                    formData.append('microsite_id', microsite_id);
                    for(let microsite_id of menus_id){
                        formData.append('menus_id[]', microsite_id);
                    }

                    window.forms.post(route, formData);

                }, 
                _ => {}
            );

    }

    

}